import './timeseries_chart_view.js.coffee'

Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.SentimentTimeseriesView extends Monitoring.Views.Charts.TimeseriesChartView
  valueField: 'count'
  chartOptions:
    yAxis:
      min: 0
    plotOptions:
      spline:
        marker:
          enabled: false
    colors: []

  initialize: ->
    @title = I18n.t('monitoring.dashboard.charts.sentiment')
    @title_en = I18n.t('monitoring.dashboard.charts.sentiment', {'locale': 'en'})
    super
    @name = 'sentiment_time_series'

  nonEmptySentiments: ->
    _.filter(@facets['sentiment'].terms, (sentiment) ->
      sentiment.count > 0 and sentiment.term != 'No sentiment'
    )

  _dataIsEmpty: ->
    @nonEmptySentiments().length == 0

  addSeries: ->
    nonEmptySentiments = @nonEmptySentiments()
    if nonEmptySentiments.length == 0
      @$el.removeClass('processing')
    else
      @chartOptions.colors = []
      _.each(nonEmptySentiments, (sentiment) =>
        query = @searchQuery.deepCopy()
        query.set('sentiment', [])
        value = sentiment.term
        query.addSentiment(value)
        query.set('interval', @intervalParam)
        @ajaxCall("/monitoring/dashboard/charts/tpm/", query.toJSON(), (response) =>
          @date_from_realtime = response.date_from_realtime if response.date_from_realtime
          @date_to_realtime = response.date_to_realtime if response.date_to_realtime
          if value == 'negative'
            @chartOptions.colors.push('#bf362e')
          else if value == 'neutral'
            @chartOptions.colors.push('#999999')
          else
            @chartOptions.colors.push('#84bd0e')
          @addSerie(value, response.values, nonEmptySentiments.length)
        )
      )
    return this

  getNewQuery: (event) ->
    query = super(event)
    query.set('sentiment' , [])
    query.addSentiment(event.point.series.name)
    return query
